export default "__VITE_ASSET__BAevHszk__"